const Upload = ({ color, type }) => {
  const regular = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6665 15.5H13.6665V9.5H16.6665L12.6665 4.5L8.6665 9.5H11.6665V15.5Z"
        fill={color}
      />
      <path
        d="M20.6665 18.5H4.6665V11.5H2.6665V18.5C2.6665 19.603 3.5635 20.5 4.6665 20.5H20.6665C21.7695 20.5 22.6665 19.603 22.6665 18.5V11.5H20.6665V18.5Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Upload;
